<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Thêm thông tin lưu trú
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Điểm đi" prop="location">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.location"
                placeholder="Điểm đi"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in locations"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Khách sạn" prop="hotel">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.hotel"
                placeholder="Khách sạn"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in hotels"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Ngày check-in" prop="checkIn">
              <el-date-picker
                v-model="form.checkIn"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                type="datetime"
                placeholder="dd/MM/yyyy HH:mm"
                format="dd/MM/yyyy HH:mm"
                :prefix-icon="' '"
                :picker-options="checkInPickerOption"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Ngày check-out" prop="checkOut">
              <el-date-picker
                v-model="form.checkOut"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                type="datetime"
                placeholder="dd/MM/yyyy HH:mm"
                format="dd/MM/yyyy HH:mm"
                :prefix-icon="' '"
                :picker-options="checkInPickerOption"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Số lượng (phòng đơn)" prop="count1">
              <el-input-number
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.count1"
                size="medium"
                placeholder="Số lượng (phòng đơn)"
                :controls="false"
                :min="0"
                :step="1"
                :precision="0"
                :max="1000"
              ></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Số lượng (phòng đôi)" prop="count2">
              <el-input-number
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.count2"
                size="medium"
                placeholder="Số lượng (phòng đôi)"
                :controls="false"
                :min="0"
                :step="1"
                :precision="0"
                :max="1000"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          {{ isEditMode ? "Lưu" : "Thêm" }}&nbsp;
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import hanhChinhUtils from "../../../services/hanhChinhUtils";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import CustomDialog from "../../common/custom-dialog";
  import hcCfgAirportService from "../../../services/maybay/hcCfgAirportService";
  import moment from "moment";
  import errorMessageFilter from "../../../filters/errorMessageFilter";

  export default {
    name: "hc-ks-add-place-dialog",
    mixins: [handleRequestErrorMixin],
    props: ["isOpen", "place"],
    components: {
      CustomDialog
    },
    data() {
      return {
        rules: {
          location: null,
          hotel: null,
          checkIn: null,
          checkOut: null,
          count1: null,
          count2: null
        },
        form: {
          location: null,
          hotel: null,
          checkIn: null,
          checkOut: null,
          count1: null,
          count2: null
        },
        locations: [],
        hotels: [],
        checkInPickerOption: {
          disabledDate: null
        }
      };
    },

    watch: {},
    computed: {
      isEditMode() {
        return !!this.place;
      }
    },

    created() {
      this.initPage();
      this.loadLocations();
      this.loadHotels();
      this.initValidationRules();
      if (this.isEditMode) this.initFormForEdit();
    },

    methods: {
      loadLocations() {
        return hanhChinhUtils
          .loadHotelLocations()
          .then(locations => (this.locations = locations));
      },

      loadHotels() {
        return hanhChinhUtils.loadHotels().then(hotels => (this.hotels = hotels));
      },

      initFormForEdit() {
        this.form.location = this.place.location;
        this.form.hotel = this.place.hotel;
        this.form.checkIn = this.place.checkIn
          ? new Date(this.place.checkIn)
          : null;
        this.form.checkOut = this.place.checkOut
          ? new Date(this.place.checkOut)
          : null;
        this.form.count1 = this.place.countRoom1;
        this.form.count2 = this.place.countRoom2;
      },

      initPage() {
        this.checkInPickerOption.disabledDate = time =>
          !(
            time.getTime() >=
            new moment(new Date())
              .startOf("date")
              .toDate()
              .getTime()
          );
      },

      loadAirports() {
        return hcCfgAirportService
          .findAll()
          .then(response => (this.airports = response.data));
      },

      initValidationRules() {
        let defaultRequiredConstrains = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "blur"
        };

        let checkInOutValidatorFn = message => {
          return (rule, value, callback) => {
            if (!value) return callback();
            if (value.getTime() < new Date().getTime())
              return callback(new Error(message));
            return callback();
          };
        };

        this.rules.location = [defaultRequiredConstrains];
        this.rules.hotel = [defaultRequiredConstrains];
        this.rules.checkIn = [
          defaultRequiredConstrains,
          {
            validator: checkInOutValidatorFn(
              "Thời gian checkin không được nhỏ hơn ngày hiện tại"
            ),
            trigger: "blur"
          }
        ];
        this.rules.checkOut = [
          defaultRequiredConstrains,
          {
            validator: checkInOutValidatorFn(
              "Thời gian checkout không được nhỏ hơn ngày hiện tại"
            ),
            trigger: "blur"
          }
        ];
      },

      validateForm() {
        return new Promise(resolve => {
          this.$refs.form.validate(valid => {
            if (!valid) {
              this.$message.error("Có lỗi nhập liệu. Vui lòng kiểm tra lại");
            } else {
              resolve();
            }
          });
        });
      },

      convertToSubmitForm() {
        return {
          location: this.form.location,
          hotel: this.form.hotel,
          checkIn: this.form.checkIn ? this.form.checkIn.getTime() : null,
          checkOut: this.form.checkOut ? this.form.checkOut.getTime() : null,
          countRoom1: this.form.count1,
          countRoom2: this.form.count2
        };
      },

      validateTimeRange() {
        return new Promise(resolve => {
          let isOk = this.form.checkOut.getTime() > this.form.checkIn.getTime();
          if (!isOk) {
            this.$message.error(
              errorMessageFilter({
                errorCode: "hcHotel.invalidTimeRange"
              })
            );
          } else {
            resolve();
          }
        });
      },

      validateCount() {
        return new Promise(resolve => {
          if (this.form.count1 + this.form.count2 <= 0) {
            this.$message.error(
              errorMessageFilter({
                errorCode: "hcHotel.places.invalidCount"
              })
            );
            return;
          }
          resolve();
        });
      },

      submit() {
        this.validateForm()
          .then(() => this.validateTimeRange())
          .then(() => this.validateCount())
          .then(() => {
            this.$emit("submit", {result: this.convertToSubmitForm()});
          });
      }
    }
  };
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-add-place-dialog.vue